@if(!!promotion) {
<div class="card">
  <h5>{{promotion.Id?'Edit':'New'}} Promotion</h5>
  <div class="p-fluid p-formgrid grid">
    <!-- <div class="field col-6">
        <label htmlFor="template">Template</label>
        <p-dropdown [options]="templates" [(ngModel)]="template"></p-dropdown>
      </div> -->
    <div class="field col-6">
      <label htmlFor="name">Name</label>
      <input pInputText id="name" type="text" [(ngModel)]="promotion.Name" />
    </div>
    <div class="field col-12">
      <p-checkbox label="Show in promotion area" binary="true" [(ngModel)]="promotion.InPromotionArea"></p-checkbox>
    </div>
    <div class="field col-12 tw-flex">
      <div>
        <label htmlFor="menus">Show in menu(s)</label>
        <p-listbox [options]="menus" [multiple]="true" [(ngModel)]="promotion.VisibleInMenuIds" optionLabel="Name"
          optionValue="Id" [checkbox]="true" [showToggleAll]="false"></p-listbox>
      </div>
    </div>



    <div class="field col-12 md:col-3">
      <label htmlFor="minAmount">Min Ordered Amount</label>
      <input pInputText type="number" [(ngModel)]="promotion.MinAmount" />
    </div>

    <div class="field col-12">
      <label htmlFor="price">Price</label>
      <brt-promotion-price [(ngModel)]="promotion.Price"></brt-promotion-price>
      <small class="tw-block tw-mt-2 tw-text-gray-500">
        How to price common offers:<br />
        • <b>Meal deal / fixed bundle price</b> (e.g. Pasta + Garlic Bread for £10): Fixed Price = <b>10</b>, leave the
        "cheaper item" option below <b>off</b>.<br />
        • <b>Buy One Get One Free</b>: Fixed Price = <b>0</b> and turn the "cheaper item" option below <b>on</b>. Item
        prices are read automatically from the menu — you do not set them here; the cheaper item becomes free.<br />
        • <b>Buy One Get One Half Price</b>: Discount Percentage = <b>50</b> and turn the "cheaper item" option below
        <b>on</b>.
      </small>
    </div>

    <div class="field col-12">
      <p-checkbox label="Free delivery" binary="true" [(ngModel)]="promotion.FreeDelivery"></p-checkbox>
    </div>

    <div class="field col-12">
      <p-checkbox label="Do not apply percentage rewards to this promotion" binary="true"
        [(ngModel)]="promotion.ExcludeFromDiscountPercentage"></p-checkbox>
    </div>

    <div class="field col-12">
      <p-checkbox label="Buy one get one discounted or free (discount or free applies to the cheaper item)"
        binary="true" [(ngModel)]="promotion.DiscountCheapest"></p-checkbox>
      <small class="tw-block tw-mt-2 tw-text-gray-500">
        Turn this <b>on</b> for every Buy-One-Get-One offer: the price above is applied only to the cheaper item(s) and
        the dearer item is charged in full. Leave it <b>off</b> only for a fixed-price meal deal where the whole bundle
        is one price.
      </small>
      @if (makesWholeOfferFree) {
      <small class="tw-block tw-mt-2 tw-font-bold" style="color:#b91c1c">
        ⚠ With Fixed Price 0 and this option off, the <b>entire</b> offer will be free (£0.00). For Buy-One-Get-One-Free,
        turn the option above on so only the cheaper item is free.
      </small>
      }
    </div>


    <div class="field col-12">
      <label>Promotion Items</label>
      <brt-promotion-item [(ngModel)]="promotion.Items"></brt-promotion-item>
    </div>

    <div class="field col-12">
      <label>Serving Hours</label>
      <div class="p-fluid">
        <div class="p-formgrid grid" *ngFor="let item of promotion.ServingHours;let index=index">
          <div class="field col-12 md:col-1">
            <p-button icon="pi pi-trash" (click)="promotion.ServingHours.splice(index,1)"></p-button>
          </div>
          <div class="field col-12 md:col-2">
            <label htmlFor="type">Order Type</label>
            <p-dropdown [options]="orderTypes" [(ngModel)]="item.OrderType"></p-dropdown>
          </div>
          <div class="field col-12 md:col-3">
            <label htmlFor="day">Days</label>
            <p-multiSelect [options]="weekDays" [(ngModel)]="item.Days"
              placeholder="Select days of week"></p-multiSelect>
          </div>
          <div class="field col-12 md:col-3">
            <label htmlFor="start-time">Start Time</label>
            <p-inputMask id="start-time" type="text" [(ngModel)]="item.StartTime" mask="99:99:99" placeholder="HH:MM" />
          </div>
          <div class="field col-12 md:col-3">
            <label htmlFor="end-time">End Time</label>
            <p-inputMask id="end-time" type="text" [(ngModel)]="item.EndTime" mask="99:99:99" placeholder="HH:MM" />
          </div>
        </div>
        <p-button label="Add new serving time" icon="pi pi-plus" (click)="promotion.ServingHours.push({})"></p-button>
      </div>
    </div>

    <div class="field col-12">
      <p-fieldset legend="UI Settings" [toggleable]="true" [collapsed]="true">
        <brt-ui-settings id="ui" [(ngModel)]="promotion.UI" [business-id]="businessId"
          [keys]="['Image:image:ai:promotion-image:' + promotion.Id,'Description:text']">
        </brt-ui-settings>
      </p-fieldset>
    </div>
  </div>

</div>
<div class="card tw-flex tw-gap-4 tw-p-4 tw-sticky tw-bottom-0 ">
  <button pButton pRipple label="Save" (click)="save()"></button>
  <button *ngIf="promotion.Id" pButton pRipple label="Apply" class="p-button-secondary" (click)="save(false)"></button>
</div>

}